<template>
  <div id="app">
    <AppWait v-if="workspaceLoading">
      App start is in progress. Please wait...
    </AppWait>
    <router-view v-else />
  </div>
</template>

<script>
import AppWait from '@/components/shared/AppWait'
import { mapActions, mapState } from 'vuex'
import { DOMAIN_ANY, DOMAIN_WORKSPACE } from '@/router/helpers'

export default {
  name: 'app',
  components: {
    AppWait
  },
  methods: {
    ...mapActions(['loadCommonData']),
    ...mapActions('auth', [
      'userMessagesHandlerBind',
      'localStorageUpdateBind',
    ]),
  },
  watch: {
    workspaceStatus(status) {
      if (status && status.status === 'ok') {
        this.loadCommonData()
      }
    }
  },
  computed: {
    ...mapState(['workspaceStatus', 'modalActiveCount']),
    ...mapState('settings', ['generalSettingsLoaded']),
    workspaceLoading() {
      const requireDomain = this.$route.meta.requireDomain || DOMAIN_ANY
      const requireWorkspaceLoading = this.$route.meta.requireWorkspaceLoading

      if (requireDomain !== DOMAIN_WORKSPACE) return false
      if (typeof requireWorkspaceLoading !== 'undefined' && !requireWorkspaceLoading) return false
      if (Object.keys(this.workspaceStatus).length === 0) return true
      return !this.generalSettingsLoaded
    }
  },
  created() {
    // bind callback on localStorage change (for tabs sync)
    this.userMessagesHandlerBind()
    this.localStorageUpdateBind()
  }
}
</script>

<style src="@/assets/appwork/bootstrap.scss" lang="scss"></style>
<style src="@/assets/appwork/appwork.scss" lang="scss"></style>
<style src="@/assets/appwork/theme-twitlight.scss" lang="scss"></style>
<style src="@/assets/appwork/colors.scss" lang="scss"></style>
<style src="@/assets/appwork/uikit.scss" lang="scss"></style>
<style src="@/assets/main.scss" lang="scss"></style>

<style lang="scss">
.modal-active {
  overflow: hidden;
}
</style>
